import { render, staticRenderFns } from "./LeftSidebarMarkets.vue?vue&type=template&id=6806635e&scoped=true&"
import script from "./LeftSidebarMarkets.vue?vue&type=script&lang=js&"
export * from "./LeftSidebarMarkets.vue?vue&type=script&lang=js&"
import style0 from "./LeftSidebarMarkets.vue?vue&type=style&index=0&id=6806635e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6806635e",
  null
  
)

export default component.exports